export const PicklistStatusNames = Object.freeze({
  open: 'Open',
  delivered: 'Delivered',
  completed: 'Completed'
});

export const PicklistAssetStatusNames = Object.freeze({
  waitingForShipment: 'WaitingForShipment',
  builtAndReadyToLoad: 'BuiltAndReadyToLoad',
  inspectedReadyToLoad: 'InspectedReadyToLoad',
  loaded: 'Loaded',
  ordered: 'Ordered',
  receivedAtJobSite: 'ReceivedAtJobSite',
  receivedAtYard: 'ReceivedAtYard',
  shipped: 'Shipped'
});
